

const row = {
  pc_infor:{
    box_paddingLeft:"10%",
    box_paddingRight:"10%",
    box_paddingTop:"0%",
    box_paddingBottom:"0%",
    row_is_shadow: 'false',
    row_border_set: {
      radio_val: 'default',
      default:{
        border_width: 0,
        border_left_width:0,
        border_right_width:0,
        border_top_width:0,
        border_bottom_width:0,
        border_color:'rgba(0,0,0,1)',
        border_style:'solid',
        border_check_list:[]
      },
      custom:{
        border_width: 0,
        border_left_width:0,
        border_right_width:0,
        border_top_width:0,
        border_bottom_width:0,
        border_color:'rgba(0,0,0,1)',
        border_style:'solid',
        border_check_list:['borderTopWidth','borderBottomWidth','borderLeftWidth','borderRightWidth']
      }
    },
    row_background_set:{
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 0)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center', //图片位置
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center', //图片位置
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
  },
  mb_infor:{
    col_style_name:'',
    box_paddingLeft:"0%",
    box_paddingRight:"0%",
    box_paddingTop:"0%",
    box_paddingBottom:"0%",
    row_is_shadow: 'false',
    row_border_set: {
      radio_val: 'default',
      default:{
        border_width: 0,
        border_left_width:0,
        border_right_width:0,
        border_top_width:0,
        border_bottom_width:0,
        border_color:'rgba(0,0,0,1)',
        border_style:'solid',
        border_check_list:[]
      },
      custom:{
        border_width: 0,
        border_left_width:0,
        border_right_width:0,
        border_top_width:0,
        border_bottom_width:0,
        border_color:'rgba(0,0,0,1)',
        border_style:'solid',
        border_check_list:['borderTopWidth','borderBottomWidth','borderLeftWidth','borderRightWidth']
      }
    },
    row_background_set:{
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 0)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center', //图片位置
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center', //图片位置
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    isShow:true
  },
  col_order_val:'default',//列顺序
  col_order_array:[],//列顺序排列


};

export default row;


// WEBPACK FOOTER //
// ./src/widgets/layout_row/style.js